import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  videoViewerWrapper: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
  },

  videoContainer: {
    maxWidth: `calc(min(90vw, ${theme.breakpoints.values.md - 240}px))`,
    maxHeight: `calc(min(90vh, ${theme.breakpoints.values.md - 160}px))`,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
  },
}));
